module.exports = __webpack_public_path__ + "img/blueQues.9237f085.svg";